import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/about-breadcrumb.webp'

const PrivacyPolicy=()=>{
    useEffect(() => {
            document.title =
              "Privacy Policy | Gurukrupa Wood Pvt. Ltd.";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Read the Privacy Policy of Gurukrupa Wood Pvt. Ltd. to understand how we collect, use and protect your information."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://gurukrupawood.com/privacy-policy");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Privacy Policy | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Read the Privacy Policy of Gurukrupa Wood Pvt. Ltd. to understand how we collect, use and protect your information."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://gurukrupawood.com/privacy-policy");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://gurukrupawood.com/privacy-policy.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Privacy Policy | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Read the Privacy Policy of Gurukrupa Wood Pvt. Ltd. to understand how we collect, use and protect your information."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://gurukrupawood.com/privacy-policy.webp"
            );
          }
          }, []);

          const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};
    
    return(
        <>
        <Breadcrumb
  pageName="Privacy Policy"
  bgImage={bgImg}
/>

         <motion.section className="privacy-policy-section container"
        variants={container}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}>

             <motion.h2 className="section-heading" variants={fadeUp}>1. Introduction</motion.h2>
         <motion.p className="section-text" variants={fadeUp}>
  Gurukrupa Wood Pvt. Ltd. (“we”, “us”, “our”) is engaged in the manufacturing and supply of wooden pallets, boxes, crates, plywood boxes, and customised industrial packaging solutions. We respect your privacy and are committed to protecting the information you share with us.
</motion.p>

          {/* Information Collection */}
          <motion.h2 className="section-heading" variants={fadeUp}>2. Information We Collect</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>We may collect information such as:</motion.p>
          <ul>
            <motion.li variants={fadeUp}>Client and supplier details (name, company, contact info)</motion.li>
            <motion.li  variants={fadeUp}>Shipping and customs documentation details</motion.li>
            <motion.li variants={fadeUp}>Website usage data (IP, cookies, forms submitted)</motion.li>
            <motion.li  variants={fadeUp}>Employee and contractor records (for HR & compliance)</motion.li>
          </ul>

          {/* Use of Info */}
          <motion.h2 className="section-heading" variants={fadeUp}>3. How We Use Your Information</motion.h2>
          <ul>
            <motion.li variants={fadeUp}>To process orders, shipments, and export documentation</motion.li>
            <motion.li variants={fadeUp}>To comply with customs, trade, and regulatory laws</motion.li>
            <motion.li variants={fadeUp}>To provide customer service and respond to inquiries</motion.li>
            <motion.li variants={fadeUp}>To improve our operations, services, and security</motion.li>
          </ul>

          {/* Disclosure */}
          <motion.h2 className="section-heading" variants={fadeUp}>4. Sharing & Disclosure</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>
            We do not sell your personal information. We may share data with:
          </motion.p>
          <ul>
            <motion.li variants={fadeUp}>Logistics partners, customs agents, and shipping companies</motion.li >
            <motion.li  variants={fadeUp}>Government authorities where legally required</motion.li >
            <motion.li  variants={fadeUp}>Service providers bound by confidentiality agreements</motion.li >
          </ul>

          {/* Security */}
          <motion.h2 className="section-heading" variants={fadeUp}>5. Security Measures</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>
            We implement industry-standard practices to protect data from
            unauthorized access, misuse, or disclosure, including encryption,
            access control, and audits.
          </motion.p>

          {/* International Transfers */}
          <motion.h2 className="section-heading" variants={fadeUp}>6. International Data Transfers</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>
            As an export-oriented company, data may be transferred internationally.
            We ensure such transfers comply with applicable data protection laws.
          </motion.p>

          {/* Rights */}
          <motion.h2 className="section-heading" variants={fadeUp}>7. Your Rights</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>You have the right to:</motion.p>
          <ul>
            <motion.li variants={fadeUp}>Access and update your personal data</motion.li>
            <motion.li variants={fadeUp}>Request deletion of your data where legally permitted</motion.li>
            <motion.li variants={fadeUp}>Withdraw consent for non-essential uses</motion.li>
            <motion.li variants={fadeUp}>Raise concerns with data protection authorities</motion.li>
          </ul>

          {/* Policy Updates */}
          <motion.h2 className="section-heading" variants={fadeUp}>8. Changes to this Policy</motion.h2>
          <motion.p className="section-text" variants={fadeUp}>
            We may revise this Privacy Policy as required by operational,
            legal, or regulatory changes. Updates will be posted on this page.
          </motion.p>

          {/* Contact */}
          <motion.h2 className="section-heading" variants={fadeUp}>9. Contact Us</motion.h2>
          <motion.p  className="section-text" variants={fadeUp}>
            For questions or concerns, reach us at:
          </motion.p >

          <div >
            <div>
              <motion.address variants={fadeUp}>
              Survey No. 674/2, Ajapar - Tappar
                Road, Vill. Bhimasar, Ta. Anjar, Dist.
                Bhuj – Kutch, Gujarat. 370 201
              </motion.address>
            </div>
            <motion.p variants={fadeUp}>
              <a href="mailto:jignesh@gurukrupawood.com"> jignesh@gurukrupawood.com</a>
            </motion.p >
            <motion.p  variants={fadeUp}>
              <a href="tel:+919624065081">+91 96240 65081</a>
            </motion.p >
          </div>
        </motion.section>
        </>
    )
}
export default PrivacyPolicy;